var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("li", [
      _vm._v(
        "\n        " +
          _vm._s(_vm.name) +
          "\n        " +
          _vm._s(_vm.preventOverflow((_vm.pageIndex - 1) * _vm.pageSize + 1)) +
          " - " +
          _vm._s(_vm.preventOverflow(_vm.pageIndex * _vm.pageSize)) +
          "\n        sur " +
          _vm._s((_vm.data && _vm.data.length) || 0) +
          " filtrés (" +
          _vm._s(_vm.total || 0) +
          " total)\n    "
      ),
    ]),
    _vm._v(" "),
    _c("nav", [
      _c(
        "ul",
        { staticClass: "pagination" },
        [
          _c(
            "li",
            {
              staticClass: "page-item",
              class: { disabled: !_vm.pageList.includes(_vm.pageIndex - 1) },
              staticStyle: { "user-select": "none" },
              on: {
                click: function ($event) {
                  return _vm.gotoPage(_vm.pageIndex - 1)
                },
              },
            },
            [
              _c("a", { staticClass: "page-link cursor-pointer" }, [
                _vm._v("Précédent"),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm._l(
            _vm.pageList.filter((p) => _vm.inSmartList(p)),
            function (i) {
              return [
                !_vm.inSmartList(i - 1) && i
                  ? _c("li", { key: i + "_", staticClass: "page-item" }, [
                      _c("span", [_vm._v("...")]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    key: i,
                    staticClass: "page-item",
                    class: { active: i == _vm.pageIndex },
                    on: {
                      click: function ($event) {
                        return _vm.gotoPage(i)
                      },
                    },
                  },
                  [
                    _c("a", { staticClass: "page-link cursor-pointer" }, [
                      _vm._v(_vm._s(i)),
                    ]),
                  ]
                ),
              ]
            }
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "page-item",
              class: { disabled: !_vm.pageList.includes(_vm.pageIndex + 1) },
              staticStyle: { "user-select": "none" },
              on: {
                click: function ($event) {
                  return _vm.gotoPage(_vm.pageIndex + 1)
                },
              },
            },
            [
              _c("a", { staticClass: "page-link cursor-pointer" }, [
                _vm._v("Suivant"),
              ]),
            ]
          ),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }